function processarCategoriaLeitura(data) {
  const categories = []
  const dataGraph = []

  data.forEach(item => {
    if (!categories.includes(item.categoira_descricao)) {
      categories.push(item.categoira_descricao)
      dataGraph.push({
        name: item.categoira_descricao,
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      })
    }
  })

  dataGraph.forEach(item => {
    data.forEach(element => {
      if (item.name === element.categoira_descricao) {
        item.data[element.mes_id - 1] += element.count_postagem_id
      }
    })
  })
  return dataGraph
}
export default processarCategoriaLeitura
